import Coupom from "./Coupom"
export default Coupom